module.exports = __webpack_public_path__ + "static/img/pico411.8c20778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico411.png
// module id = IYQR
// module chunks = 0